import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { getSlug } from "../../../utils/utils";
import useViewPort from "../../../../hook/useViewPort";
import { CollectionName } from "../../Atoms/CollectionName";
import { CollectionHeroImage } from "../../Atoms/CollectionHeroImage";
import ImageType4 from "../../../../components/molecules/image-type-4";
import { collectionToStories, Link, ResponsiveImage } from "@quintype/components";
import "./collection-only-layout.m.css";

const CollectionOnlyLayout = ({ collection, config }) => {
  const showSection = get(collection, ["associated-metadata", "show-section-title"], true);
  const showSectionHero = get(collection, ["associated-metadata", "show-section-hero-image"], false);
  const typeCollection = get(collection, ["items"]);
  const filterCollection = typeCollection.filter((types) => types.type === "collection");
  const bgColor = get(collection, ["associated-metadata", "Type a number from 1-14 for layout background colors"]) || 1;
  const validNumber = bgColor >= 1 && bgColor <= 14 ? bgColor : 1;
  const colorClass = `color-black-${validNumber}`;
  const storiesFromCollection = collectionToStories(collection);
  const defaultImage= get(config, ["publisher-attributes", "defaultImageKey"], "")
  const { viewports } = useViewPort();
  return (
    <>
      {filterCollection&&filterCollection.length > 0 ? (
        <div styleName={`container ${colorClass}`} className="collection-only-layout">
          {collection.slug!=="channel-2"&& <div styleName="collection-name-upper" className={viewports?viewports:""}>
            {/* <h2 style={{ color: "white" }}>{collection.name} </h2> */}
            <CollectionName collection={collection} />
            <i className="ri-arrow-right-line"></i>
          </div>}
          {collection.slug==="channel-2"&& <div className={viewports?viewports:""}>
           {collection.slug==="channel-2"&&
           <div styleName="collection-name">
            <Link href="/channel-two">
              <h2>{collection.name}</h2>
            </Link>
            <i className="ri-arrow-right-line"></i>
            </div>}

          </div>}
          <div styleName="image-grid" className={viewports?viewports:""}>
            {filterCollection.map((collectionItem) => {
              let slug = (collectionItem && getSlug(collectionItem, config)) || "";
              const collectionHeroImgS3Key =
                (collectionItem.metadata &&
                collectionItem.metadata["cover-image"] &&
                collectionItem.metadata["cover-image"]["cover-image-s3-key"]) || defaultImage
                let collectionSlug= collectionItem.slug;
                if(collectionItem.slug==="etusivu-lammas"){
                  slug="/lammas"
                }else if(collectionItem.slug==="etusivu-channel-two"){
                  slug="/channel-two"
                }
                if(!collectionHeroImgS3Key){
                  return null;
                }

              return (
                <div id={collectionItem.id} styleName="image-container">
                  <Link href={slug}>
                 <div styleName="responsive-img">
                 {collectionHeroImgS3Key&&
                    <ResponsiveImage
                        aspectRatio={[1,1]}
                        defaultWidth={480}
                        widths={[250,480,640]}
                        slug={collectionHeroImgS3Key}
                        alt={collectionHeroImgS3Key}
                      />
                      }
                  </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div styleName={`container ${colorClass}`}>
          {showSectionHero&&
          <CollectionHeroImage config={config} collection={collection} />}
          <div styleName="collection-name" className="default-container">
            <CollectionName collection={collection} />
            <i className="ri-arrow-right-line"></i>
          </div>
          <div styleName="image-grid" className="default-container">
            {storiesFromCollection.map((storyItem) => (
              <div id={storyItem.id} styleName="image-container">
                <ImageType4 story={storyItem} aspectRatio={[[9, 16]]} showOverlay />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

CollectionOnlyLayout.propTypes = {
  collection: object,
};
export { CollectionOnlyLayout };

CollectionOnlyLayout.storyLimit = 22;

